import { RawLocation } from "vue-router";
import { Auth0Client } from "@auth0/auth0-spa-js";

export type AppState = {
  targetUrl?: string | RawLocation;
};

export function isAuth0Callback(): boolean {
  return ["code=", "state="].every((subject) =>
    window.location.search.includes(subject)
  );
}

export function isAuth0ErrorCallback(): boolean {
  return ["error=", "error_description=", "state="].every((subject) =>
    window.location.search.includes(subject)
  );
}

// A used callback URL (back button, reload, other tab) has no matching Auth0 transaction
const STALE_CALLBACK_ERRORS = ["missing_transaction", "state_mismatch"];

export async function handleRedirectCallbackIfPending(
  client: Pick<Auth0Client, "handleRedirectCallback">
): Promise<void> {
  try {
    await client.handleRedirectCallback();
  } catch (error) {
    if (!STALE_CALLBACK_ERRORS.includes(error?.error)) {
      throw error;
    }
  }
}

export function getRedirectUri(): string {
  return `${window.location.protocol}//${window.location.host}/callback`;
}
